export const brand = {
  name: "LUNAVOA",
  tagline: "A world that grows with you.",
  domains: {
    public: "lunavoa.org",
    parent: "lunavoa.org/app",
    admin: "lunavoa.org/admin",
    api: "lunavoa.org/api",
  },
} as const;

export function surfaceForHost(_hostname: string): "public" | "parent" | "admin" {
  return "public";
}
